import { Controller } from "@hotwired/stimulus";
import { application } from "src/stimulus/application";

// landIeul: components/CompanyIndex/HouseMakerIndex/index.tsx の「もっと見る」開閉。
// 初期非表示の企業カセット (hiddenItem) を全表示し、ボタン (buttonWrap) を隠す。
class SiteCompanyHouseMakerIndexController extends Controller {
  static targets = ["hiddenItem", "buttonWrap", "lastVisibleItem"];

  declare readonly hiddenItemTargets: HTMLElement[];
  declare readonly buttonWrapTarget: HTMLElement;
  declare readonly hasButtonWrapTarget: boolean;
  declare readonly lastVisibleItemTarget: HTMLElement;
  declare readonly hasLastVisibleItemTarget: boolean;

  showMore(): void {
    this.hiddenItemTargets.forEach((el) => {
      el.style.display = "";
    });
    // 全表示後は真の最終要素に :last-of-type が効くため、可視最終要素の border 打ち消しを解除する
    if (this.hasLastVisibleItemTarget) {
      this.lastVisibleItemTarget.classList.remove(
        "CompanyHouseMakerIndex_houseMakerIndex__itemLastVisible"
      );
    }
    if (this.hasButtonWrapTarget) {
      this.buttonWrapTarget.style.display = "none";
    }
  }
}

application.register("site--company--house-maker-index", SiteCompanyHouseMakerIndexController);
